import { List, styled } from '@mui/material';

const StyledAvailabilityStatusList = styled(List)(({ theme }) => ({
  columnGap: theme.spacing(5),
  display: 'flex',
  justifyContent: 'center'
}));

export default StyledAvailabilityStatusList;
